import {
	GET_SALES_REPORT_REQUEST,
	GET_SALES_REPORT_SUCCESS,
	GET_SALES_REPORT_FAILED,
	GET_TODAY_SALES_REQUEST,
	GET_TODAY_SALES_SUCCESS,
	GET_TODAY_SALES_FAILURE,
} from '../actions/index';

const initialState = {
	report: null,
	todaysTotal: 0,
	todaysTotalLoading: false,
	loading: false,
	error: null,
};

const salesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_TODAY_SALES_REQUEST:
			return {
				...state,
				loading: true,
				todaysTotalLoading: true,
			};
		case GET_SALES_REPORT_REQUEST:
			return {
				...state,
				loading: true,
			};
		case GET_SALES_REPORT_SUCCESS:
			return {
				...state,
				loading: false,
				report: action.payload,
			};
		case GET_TODAY_SALES_SUCCESS:
			console.log(action.payload)
			return {
				...state,
				loading: false,
				todaysTotalLoading: false,
				todaysTotal: action.payload.total,
			};
		case GET_TODAY_SALES_FAILURE:
			return {
				...state,
				loading: false,
				todaysTotalLoading: false,
				error: action.payload,
			};
		case GET_SALES_REPORT_FAILED:
			return { ...state, loading: false, error: action.payload };
		default:
			return state;
	}
};

export default salesReducer;